export enum CreateTaskOperation{
    CREATE = 0,
    EDIT = 1,
    DUPLICATE = 2
  }